import React, { ChangeEvent, CSSProperties, useEffect, useState } from 'react'
import DatePicker, { registerLocale } from 'react-datepicker'
import $ from 'jquery'
import {
  ExternalProfileType,
  UpdateProfileType,
} from '../../containers/SignInPage/types'
import ru from 'date-fns/locale/ru'
registerLocale('ru', ru)
import moment from 'moment'
import notification from '../../components/Notification'

// Styles
import './styles.scss'

// Icons
import IconEdit from './images/iconEdit'
import IconSave from './images/iconSave'
import IconCancel from './images/iconCancel'

export default ({
  profile,
  style,
  onSave,
  typeProfile,
  changeProfileRole,
  error,
}: {
  profile: ExternalProfileType
  style?: CSSProperties
  onSave: (data: UpdateProfileType) => void
  typeProfile: 'teacher' | 'student' | ''
  changeProfileRole: (type: 'teacher' | 'student') => void
  error: string
}) => {
  const [isEdit, setIsEdit] = useState<boolean>(false)
  const [name, setName] = useState<string>('')
  const [middleName, setMiddleName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [openSex, setOpenSex] = useState<boolean>(false)
  const [sex, setSex] = useState<string>('')
  const [isOpenCalendar, setIsOpenCalendar] = useState<boolean>(false)
  const [birthday, setBirthday] = useState<Date | null>(null)
  const [errorDate, setErrorDate] = useState<boolean>(false)
  const [isCheckFields, setIsCheckFields] = useState<boolean>(false)

  const initialDefaultValues = () => {
    if (profile.birthdate) {
      setBirthday(moment(profile.birthdate).toDate())
    } else {
      setBirthday(null)
    }
    setName(profile.name || '')
    setMiddleName(profile.patronymic || '')
    setLastName(profile.surname || '')
    setSex(profile.gender || '')
  }

  useEffect(() => {
    if (error) {
      if (error.includes('Дату рождения')) {
        setErrorDate(true)
      }
    }
  }, [error])

  useEffect(() => {
    $(() => {
      $(document).on('click', event => {
        const $target = $(event.target)
        if (
          !$target.closest('.sex__select').length &&
          $('.sex__select').hasClass('active')
        ) {
          setOpenSex(false)
        }
      })
    })
    if (profile) {
      initialDefaultValues()
    }
  }, [profile])

  const onChangeLastName = (event: ChangeEvent<HTMLInputElement>) => {
    setLastName(event.currentTarget.value)
  }

  const onChangeName = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.currentTarget.value)
  }

  const onChangeMiddleName = (event: ChangeEvent<HTMLInputElement>) => {
    setMiddleName(event.currentTarget.value)
  }

  const handleSave = () => {
    setIsCheckFields(true)
    if (moment(birthday) > moment()) {
      setErrorDate(true)
      notification('error', '', 'Дата рождения не может быть больше текущей')
      return
    }
    if (name.length && lastName.length && birthday && sex) {
      if (typeProfile === 'student') {
        if (moment().diff(birthday, 'years') >= 20) {
          changeProfileRole('teacher')
        }
      }
      if (typeProfile === 'teacher') {
        if (moment().diff(birthday, 'years') < 20) {
          changeProfileRole('student')
        }
      }
      onSave({
        external_profile: {
          name,
          surname: lastName,
          patronymic: middleName,
          gender: sex,
          birthdate: moment(birthday).format('YYYY-MM-DD'),
        },
      })
      setIsEdit(false)
    }
  }

  return (
    <div style={style} className={'personal-edit-block'}>
      <div className={'personal-edit-block__header'}>
        <span className={'title'}>
          Личная
          <br />
          информация
        </span>
        <div className={'nav'}>
          {isEdit ? (
            <>
              <IconSave onClick={handleSave} style={{ marginRight: 9 }} />
              <IconCancel
                onClick={() => {
                  setIsEdit(false)
                  setIsCheckFields(false)
                  initialDefaultValues()
                }}
              />
            </>
          ) : (
            <IconEdit onClick={() => setIsEdit(true)} />
          )}
        </div>
      </div>
      <div className={'personal-edit-block__column'}>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Фамилия:</div>
          <input
            value={lastName}
            disabled={!isEdit}
            style={
              !lastName.length
                ? { background: '#FCE5DF' }
                : !isEdit
                ? { background: 'rgba(25, 120, 178, 0.15)' }
                : {}
            }
            onChange={onChangeLastName}
          />
        </div>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Имя:</div>
          <input
            value={name}
            disabled={!isEdit}
            style={
              !name.length
                ? { background: '#FCE5DF' }
                : !isEdit
                ? { background: 'rgba(25, 120, 178, 0.15)' }
                : {}
            }
            onChange={onChangeName}
          />
        </div>
        <div className={'personal-edit-block__column-field'}>
          <div className={'label'}>Отчество:</div>
          <input
            value={middleName}
            disabled={!isEdit}
            style={!isEdit ? { background: 'rgba(25, 120, 178, 0.15)' } : {}}
            onChange={onChangeMiddleName}
          />
        </div>
        <div className={'personal-edit-block__column-additional'}>
          <div className={'sex'}>
            <div className={'label'}>Пол:</div>
            <div className={isEdit ? 'sex__outer' : 'sex__outer no-edit'}>
              <div
                onClick={() => (isEdit ? setOpenSex(!openSex) : null)}
                className={openSex ? 'sex__select active' : 'sex__select'}
                style={!sex && openSex ? { height: 134 } : {}}
              >
                <div
                  className={openSex ? 'value active' : 'value'}
                  style={
                    isEdit && isCheckFields && !sex
                      ? { background: '#fce5df', border: '1px solid red' }
                      : {}
                  }
                >
                  {sex ? (sex === 'male' ? 'М' : 'Ж') : '?'}
                </div>
                {sex ? (
                  openSex ? (
                    <div
                      className={'option'}
                      onClick={() => {
                        if (sex === 'male') {
                          setSex('female')
                        } else {
                          setSex('male')
                        }
                      }}
                    >
                      {sex === 'male' ? 'Ж' : 'М'}
                    </div>
                  ) : null
                ) : openSex ? (
                  <>
                    <div className={'option'} onClick={() => setSex('female')}>
                      Ж
                    </div>
                    <div className={'option'} onClick={() => setSex('male')}>
                      М
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>
          <div
            className={
              (errorDate || !birthday) && isCheckFields
                ? 'birthday error'
                : 'birthday'
            }
          >
            <div className={'label'}>
              Дата
              <br />
              рождения:
            </div>
            <div
              className={
                isOpenCalendar ? 'birthday__date open' : 'birthday__date'
              }
            >
              <DatePicker
                selected={birthday}
                onChange={(date: Date) => {
                  setErrorDate(false)
                  setBirthday(date)
                }}
                locale={'ru'}
                dateFormat={'P'}
                onCalendarOpen={() => setIsOpenCalendar(true)}
                onCalendarClose={() => setIsOpenCalendar(false)}
                disabled={!isEdit}
                popperPlacement={'bottom'}
                popperProps={{
                  placement: 'bottom',
                  modifiers: [
                    {
                      name: 'flip',
                      options: {
                        enabled: false,
                        fallbackPlacements: ['bottom'],
                      },
                    },
                  ],
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
